import { LCTranslationKeys } from "../../types";

export const translations: { [key in LCTranslationKeys]: string } = {
  NO_RESULTS_WITHIN_RADIUS:
    "Sorry, there are no results for this search within the specified radius around the selected location",
  LIMITED_RESULTS: "Limited results for this search within a radius of ",
  CALCULATE_COMMUTE: "Calculate commute",
  MINUTE: "Minute",
  HOUR: "Hour",
  SEARCH_MAP: "Search map...",
  NO_ROUTE: "No route available",
  TRY_SUGGESTION: "Try another query.",
  FAST_ROUTE: "Fastest Route",
  WALKING: "Walking",
  DRIVING: "Driving",
  KM: "km",
  M: "m",
  MI: "mi",
  YD: "yd",
  OPEN_LAT: "Get free report",
  LAT_TOOLTIP:
    "Download your free neighborhood report for this property, which includes a profile of the neighborhood including demographics, climate information, and critical location insights.",
};
